import { useId } from "react";

/**
 * Marca do CosmosLeads: o planeta com anel.
 *
 * Geometria medida no desenho entregue pelo proprietário (1024 × 1024, centro
 * no meio): planeta de raio 256, anel com eixo de 392,5 × 127,5 inclinado −27°
 * e traço de 44, e um vão de 30 de cada lado onde o anel passa na frente do
 * planeta. O vão é recortado do planeta por máscara, não pintado com a cor do
 * fundo: assim a marca fica certa sobre qualquer superfície e nos dois temas.
 *
 * A metade de trás do anel é desenhada antes do planeta, que a cobre; a metade
 * da frente vem por cima. A máscara recebe um id único por instância porque o
 * símbolo aparece no topo e no login ao mesmo tempo, e id repetido em SVG faz o
 * segundo desenho usar a máscara do primeiro.
 */
const FRONT_ARC = "M349.73 -178.19 A392.5 127.5 -27 0 1 -349.73 178.19";

export function BrandMark({ size = 30 }: { size?: number }) {
  const maskId = useId();
  return (
    <svg
      width={size}
      height={size}
      viewBox="-392 -392 784 784"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <mask id={maskId} maskUnits="userSpaceOnUse" x="-392" y="-392" width="784" height="784">
          <rect x="-392" y="-392" width="784" height="784" fill="#fff" />
          <path d={FRONT_ARC} stroke="#000" strokeWidth="104" />
        </mask>
      </defs>
      <ellipse
        rx="392.5"
        ry="127.5"
        transform="rotate(-27)"
        stroke="var(--brand)"
        strokeWidth="44"
      />
      <circle r="256" fill="var(--brand)" mask={`url(#${maskId})`} />
      <path d={FRONT_ARC} stroke="var(--brand)" strokeWidth="44" />
    </svg>
  );
}

export function BrandWordmark() {
  return (
    <span className="cx-brand-name">
      <b>Cosmos</b>
      <span>Leads</span>
    </span>
  );
}
